import type { ReactNode } from 'react'

interface MaintenancePageProps {
  /**
   * ロゴコンポーネント。必須。
   */
  logo: ReactNode
}

/**
 * アプリケーション全体で一貫したメンテナンス画面を提供するためのページレベルコンポーネント。
 * 表示される文言は全アプリで統一されています。
 */
function TenantMaintenancePage({ logo }: MaintenancePageProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 font-sans">
      <div className="w-11/12 max-w-2xl rounded-lg bg-white p-8 text-center shadow-sm">
        <div className="mb-8 flex justify-center">
          <div className="w-48">{logo}</div>
        </div>
        <h1 className="mb-4 font-medium text-2xl text-gray-800">システムメンテナンス中</h1>
        <div className="mb-4 text-gray-600 leading-relaxed">
          <p>
            現在、法人管理者がメンテナンス作業を実施しているため、
            <br />
            一時的にシステムをご利用いただけません。
          </p>
          <p>メンテナンス終了まで今しばらくお待ちください。</p>
        </div>
      </div>
    </div>
  )
}

export { TenantMaintenancePage }
